import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../../views/textNumberEntryView';
import NumberView from '../../../views/numberTNView';
import MenuContext from '../../../../context/menuContext';

function SupplyTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);

  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={54}
      defaultKey4={50}
      defaultKey5={57}
      defaultKey6={62}
      defaultKey7={65}
      defaultKey8={0}
      defaultKey9={54}
      defaultKey10={50}
      defaultKey11={6}
      defaultKey12={57}
      onSave={onExit}
      onLeftHold={onExit}
      title="SUPPLY Transmitter"
      caption="0x38, 0xF3, 0x85, 0x82, 0x08, 0x20"
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default SupplyTN;
